module.exports = __webpack_public_path__ + "img/415d710.png";